var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.001,
    height: 75.001,
    viewBox: "0 0 75.001 75.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step1",
    transform: "translate(-670 -2078.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M-11489.5-8176a37.257,37.257,0,0,1-14.595-2.947,37.393,37.393,0,0,1-11.921-8.038,37.359,37.359,0,0,1-8.037-11.92,37.242,37.242,0,0,1-2.947-14.6,37.241,37.241,0,0,1,2.947-14.595,37.374,37.374,0,0,1,8.037-11.921,37.374,37.374,0,0,1,11.921-8.037A37.241,37.241,0,0,1-11489.5-8251a37.242,37.242,0,0,1,14.6,2.947,37.374,37.374,0,0,1,11.921,8.037,37.417,37.417,0,0,1,8.037,11.921A37.241,37.241,0,0,1-11452-8213.5a37.242,37.242,0,0,1-2.947,14.6,37.392,37.392,0,0,1-8.037,11.92,37.393,37.393,0,0,1-11.921,8.038A37.261,37.261,0,0,1-11489.5-8176Zm-2.893-43.886h0v20.808h6.358v-28.156h-.584l-12.018,4.275v4.95l6.242-1.878Z",
    transform: "translate(12197 10329.676)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.904afcf662ead2092578b386d36f0d00.svg";
export { ForwardRef as ReactComponent };